module.exports = __webpack_public_path__ + "static/media/NYY_Logo_Active.538bdc31.svg";